// src/constants/articleOptions.ts
// Listes partagées entre CreateArticlePage et EditArticlePage.

export const AVAILABLE_CATEGORIES = [
  'Architecture Logicielle',
  'Back-End',
  'Base De Données',
  'Cloud',
  'Conteneurisation',
  'Cryptographie',
  'Culture Dev',
  'DevOps',
  'Embarqué',
  'Front-End',
  'Gestion De Projet',
  'Génie Logiciel',
  'Infrastructure',
  'Intelligence Artificielle',
  'Jeux Vidéo',
  'Linux',
  'Machine Learning',
  'Mathématiques',
  'Mobile',
  'Monitoring',
  'Moteurs De Jeu',
  'Micro-Services',
  'Optimisation',
  'Outillage',
  'Paradigmes',
  'Performance',
  'Protocoles Réseau',
  'Qualité Logicielle',
  'Réseaux',
  'Réseaux De Neurones',
  'Robotique',
  'Sécurité',
  'Serverless',
  "Systèmes D'Exploitation",
  'Systèmes Distribués',
  'Systèmes Temps Réel',
  'Science Des Données',
  'Tests',
  'Traitement Du Signal',
  'Traitement Des Images',
  'UI / UX',
  'Versionnement',
  'Vie De Développeur',
  'Vision Par Ordinateur',
  'WebAssembly',
  'Web Scraping',
  'Windows',
  'Workflow CI/CD',
  'Electronique',
  'Accessibilité',
  'Animation',
  'Audio',
  'Blockchain',
  'Carrière',
  'Compilation',
  "Conception D'API",
  'Design Patterns',
  'Documentation',
  'Expérience Développeur',
  'Formats De Données',
  'Frameworks CSS',
  'Gestion De La Mémoire',
  'Green IT',
  'Hardware',
  'Internet Des Objets',
  'Langage De Programmation',
  'Low Code / No Code',
  'Messagerie',
  'Méthodologies Agile',
  'Open Source',
  'Orchestration',
  'Outils IA',
  'PWA',
  'Reverse Engineering',
  'Runtime',
  'Scripting',
  'Simulation',
  'Stockage',
  'Streaming',
  'Temps Réel',
  'Traitement Du Langage Naturel',
  'Veille Technologique',
  'Visualisation De Données',
  'Web3',
]

export const AVAILABLE_TAGS = [
  '.NET',
  'Angular',
  'Ansible',
  'Apache Kafka',
  'Arduino',
  'ASP.NET',
  'ASP.NET Core',
  'AWS',
  'Azure',
  'Bash',
  'Blazor',
  'Bootstrap',
  'C',
  'C#',
  'C++',
  'Cassandra',
  'Chocolatey',
  'CMake',
  'CouchDB',
  'CSS',
  'Cypress',
  'D3.js',
  'Dart',
  'Deno',
  'Django',
  'Docker',
  'DynamoDB',
  'Electron',
  'Elasticsearch',
  'Entity Framework',
  'Express.js',
  'FastAPI',
  'FFmpeg',
  'Firebase',
  'Flask',
  'Flutter',
  'Gatsby',
  'Git',
  'GitHub Actions',
  'GitLab CI',
  'Go',
  'Godot',
  'GraphQL',
  'Grpc',
  'Haskell',
  'HTML',
  'Ionic',
  'Java',
  'JavaScript',
  'Jenkins',
  'Jest',
  'JetBrains Rider',
  'jQuery',
  'Julia',
  'Kafka',
  'Kotlin',
  'Kubernetes',
  'Laravel',
  'Linux',
  'Lua',
  'MariaDB',
  'MAUI',
  'MinIO',
  'MongoDB',
  'MQTT',
  'MySQL',
  'Nest.js',
  'Next.js',
  'Nginx',
  'Node.js',
  'Nuxt.js',
  'OpenAI',
  'OpenCV',
  'OpenTelemetry',
  'PHP',
  'PostgreSQL',
  'Prometheus',
  'Protobuf',
  'Python',
  'PyTorch',
  'RabbitMQ',
  'React',
  'React Native',
  'Redis',
  'REST',
  'RTOS',
  'Ruby',
  'Rust',
  'Scala',
  'SignalR',
  'Solidity',
  'Spring Boot',
  'SQLite',
  'STM32',
  'Svelte',
  'Swift',
  'Tailwind CSS',
  'TensorFlow',
  'Terraform',
  'Three.js',
  'TypeScript',
  'Unity',
  'Unreal Engine',
  'Vim',
  'Visual Studio Code',
  'Vue.js',
  'WebGL',
  'WebRTC',
  'WebSocket',
  'WinForms',
  'WPF',
  'Xamarin',
  'xUnit',
  'YAML',
  'Zod',
  'Astro',
  'Bun',
  'Caddy',
  'ClickHouse',
  'CUDA',
  'Datadog',
  'EF Core',
  'Electron.js',
  'Figma',
  'Grafana',
  'gRPC',
  'Helm',
  'JWT',
  'Keycloak',
  'Kong',
  'LibreOffice',
  'LLM',
  'LangChain',
  'Mermaid',
  'Mikrotik',
  'Mosquitto',
  'n8n',
  'Nats',
  'Neo4j',
  'OpenShift',
  'OpenVPN',
  'Packer',
  'PlatformIO',
  'PowerShell',
  'Prisma',
  'Pulumi',
  'R',
  'Raspberry Pi',
  'SciPy',
  'Seq',
  'Skia',
  'SQLServer',
  'Supabase',
  'Temporal',
  'TimescaleDB',
  'Traefik',
  'Turborepo',
  'Vite',
  'Vitest',
  'Vault',
  'WireGuard',
  'Zabbix',
  'Arrow',
  'Avro',
  'CockroachDB',
  'Dagger',
  'Faust',
  'Fluentd',
  'Forgejo',
  'Gitea',
  'Helix',
  'Jaeger',
  'Kibana',
  'Loki',
  'Minio',
  'Nix',
  'OpenAPI',
  'Ory',
  'Penpot',
  'Percona',
  'Podman',
  'Refit',
  'Serilog',
  'SonarQube',
  'Tauri',
]
